import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import brandImg1 from '../../assets/img/brand/brand-1-1.png';
import brandImg2 from '../../assets/img/brand/brand-1-2.png';
import brandImg3 from '../../assets/img/brand/brand-1-3.png';
import brandImg4 from '../../assets/img/brand/brand-1-4.png';
import brandImg5 from '../../assets/img/brand/brand-1-5.png';
import brandImg6 from '../../assets/img/brand/brand-1-6.png';

const Brand = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '6',
    spaceBetween: 45,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      1400: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 2,
      },
    },
  };

  // Brand list
  const slides = [
    { id: 1, image: brandImg1 },
    { id: 2, image: brandImg2 },
    { id: 3, image: brandImg3 },
    { id: 4, image: brandImg4 },
    { id: 5, image: brandImg5 },
    { id: 6, image: brandImg6 },
    { id: 7, image: brandImg1 },
    { id: 8, image: brandImg2 },
  ];

  return (
    <div id="it-brand" className="it-brand-area pt-95 pb-105">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="it-brand-wrap">
              <div className="swiper-container it-brand-active">
                <Swiper
                  modules={[Autoplay]}
                  {...sliderOption}
                  className="swiper-wrapper"
                >
                  {slides.map((slide) => (
                    <SwiperSlide key={slide.id} className="swiper-slide">
                      <div className="it-brand-item">
                        <img src={slide.image} alt="" />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brand;
